import Markdown from 'markdown-to-jsx';

import { Option } from '../../models/FlowChart';

import './Glossary.light.scss';
import './Glossary.dark.scss';

interface Props {
  item?: Option;
}

export function Glossary(props: Props) {
  if (!props.item) {
    return null;
  }
  return (
    <article className='glossary'>
      <header>
        <h2>{props.item.label}</h2>
      </header>
      {props.item.description?.map((item: string) => (
        <div
key={item.length}
className='glossary-item'>
          <Markdown>{item}</Markdown>
        </div>
      ))}
    </article>
  );
}
